// extracted by mini-css-extract-plugin
export var course = "style-module--course--07116";
export var course__elem = "style-module--course__elem--b218a";
export var course__img = "style-module--course__img--558f9";
export var course__imgDescription = "style-module--course__img-description--e6fd0";
export var course__item = "style-module--course__item--01e61";
export var course__itemDescription = "style-module--course__item-description--5b5ce";
export var course__title = "style-module--course__title--25e61";